module.exports = __webpack_public_path__ + "img/seckill.2ba27eea.png";